import { BigHeadline } from '@hg/stylizator/components'
import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'

import { useCTAAttributes } from 'app/blocks/hooks/useCTA'
import { ICTAAttributes } from 'app/helpers/CTAInspectorPanels'
import LazyLoadMedia from 'app/helpers/LazyLoadMedia'

export interface IAttributes
  extends Pick<React.ComponentProps<typeof BigHeadline>, 'heading' | 'background' | 'callToActionIcon'>,
    ICTAAttributes {
  leftBeeUrl: string
  rightBeeUrl: string
  mobileBeeUrl: string
}

const BigHeadlineBlock: React.FC<IWPGBlock> = (props) => {
  const attributes = props.attrs as IAttributes

  const { callToAction } = useCTAAttributes(attributes)

  return (
    <BigHeadline
      heading={attributes.heading}
      background={attributes.background}
      callToAction={callToAction}
      callToActionIcon={attributes.callToActionIcon}
      leftBee={attributes.leftBeeUrl ? <LazyLoadMedia width="auto" mediaUrl={attributes.leftBeeUrl} /> : undefined}
      rightBee={attributes.rightBeeUrl ? <LazyLoadMedia mediaUrl={attributes.rightBeeUrl} /> : undefined}
      mobileBee={
        attributes.mobileBeeUrl ? <LazyLoadMedia width="auto" mediaUrl={attributes.mobileBeeUrl} /> : undefined
      }
    />
  )
}

export default BigHeadlineBlock
